export default __webpack_public_path__ + "static/media/Group 326.cf55b779.png";